<template>
  <div class="progress-header" :class="[colorVariant]">
    <div class="header-text">
      <div>{{ headerText }}</div>
    </div>
    <div class="square-images">
      <img :src="require(`@/assets/onboarding/${topImagePath}`)">
      <img :src="require(`@/assets/onboarding/${bottomImagePath}`)">
    </div>
  </div>
</template>

<script>
import ModalBus from '../../event-bus/modal-bus';

export default {
  name: 'ProgressHeader',
  props: {
    headerText: {
      type: String,
    },
    colorVariant: {
      type: String,
      validator: val => ['green', 'red', 'blue'].includes(val),
    },
    topImagePath: {
      type: String,
    },
    bottomImagePath: {
      type: String,
    },
  },
  methods: {
    openPopup() {
      ModalBus.$emit('open', {
        component: this.BaseToolTip,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .progress-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.green {
      background-color: $riseup_v2_green;
    }
    &.blue {
      background-color: $riseup_v2_blue;
    }
    &.red {
      background-color: $riseup_v2_red;
    }

    .header-text {
      @include responsive-padding;
      color: $riseup_white;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.27;
      display: flex;
      flex-direction: column;
    }

    .square-images {
      display: flex;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/onboarding/ProgressHeader.vue